import React from 'react';
import Th from './th';

export default ({
  field,
  label,
  width,
  sort,
  onSort,
  alignCenter = true,
  sticky = true,
  backgroundColor,
  color
}) => {

  const renderIcon = () => {
    if (!sort || sort.field !== field) return null;

    return sort.direction === 'asc'
      ? <i className="fas fa-sort-amount-down-alt" />
      : <i className="fas fa-sort-amount-up" />;
  };

  return (
    <Th
      sticky={sticky}
      alignCenter={alignCenter}
      width={width}
      backgroundColor={backgroundColor}
      color={color}
      style={{ cursor: 'pointer', userSelect: 'none' }}
      onClick={() => {
        if (onSort) {
        onSort(field);
      }}}
    >
      {label} {renderIcon()}
    </Th>
  );
};
